import {
    MyPermitsActionTypes,
    LOAD_MY_PERMITS_STARTED,
    SELECT_PERMIT,
    LOAD_MY_PERMITS_SUCCESSFUL,
    LOAD_MY_PERMITS_FAILED,
    LOAD_CLIENT_ROLES_STARTED,
    LOAD_CLIENT_ROLES_SUCCESSFUL,
    LOAD_CLIENT_ROLES_FAILED,
    LOAD_REFERENCE_PROCEDURES_SUCCESSFUL,
    SET_SHOW_EXPIRED_PERMITS_FLAG,
    SET_SELECTED_PROJECT,
    CLOSE_SESSION_EXPIRY_ALERT,
    PERMIT_PENDING_SYNC_UPDATED_SUCCESSFUL,
} from "./types";
import { Project } from "../../models/Project";
import { ReferenceProcedure } from "../../models/ReferenceProcedure";
import { Permit } from "../../models/Permit";
import { Role } from "../../models/Role";

export function loadMyPermitsStarted(): MyPermitsActionTypes {
    return {
        type: LOAD_MY_PERMITS_STARTED,
    };
}

export function loadMyPermitsSuccessful(permits: Permit[]): MyPermitsActionTypes {
    return {
        type: LOAD_MY_PERMITS_SUCCESSFUL,
        permits,
    };
}

export function loadMyPermitsFailed(error: Error): MyPermitsActionTypes {
    return {
        type: LOAD_MY_PERMITS_FAILED,
        error,
    };
}

export function loadClientRolesStarted(): MyPermitsActionTypes {
    return {
        type: LOAD_CLIENT_ROLES_STARTED,
    };
}

export function loadClientRolesSuccessful(clientRoles: Role[]): MyPermitsActionTypes {
    return {
        type: LOAD_CLIENT_ROLES_SUCCESSFUL,
        clientRoles,
    };
}

export function loadClientRolesFailed(error: Error): MyPermitsActionTypes {
    return {
        type: LOAD_CLIENT_ROLES_FAILED,
        error,
    };
}

export function loadReferenceProceduresSuccessful(referenceProcedures: ReferenceProcedure[]): MyPermitsActionTypes {
    return {
        type: LOAD_REFERENCE_PROCEDURES_SUCCESSFUL,
        referenceProcedures,
    };
}

export function selectPermit(permitId: string): MyPermitsActionTypes {
    return {
        type: SELECT_PERMIT,
        permitId,
    };
}

export function setShowExpiredPermitsFlag(value: boolean): MyPermitsActionTypes {
    return {
        type: SET_SHOW_EXPIRED_PERMITS_FLAG,
        value,
    };
}

export function setSelectedProject(value: Project | null): MyPermitsActionTypes {
    return {
        type: SET_SELECTED_PROJECT,
        value,
    };
}

export function closeSessionExpiryAlert(value: Date): MyPermitsActionTypes {
    return {
        type: CLOSE_SESSION_EXPIRY_ALERT,
        value,
    };
}

export function permitPendingSyncUpdatedSuccessful(permitId: string): MyPermitsActionTypes {
    return {
        type: PERMIT_PENDING_SYNC_UPDATED_SUCCESSFUL,
        permitId,
    };
}
